import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTimes } from "@fortawesome/free-solid-svg-icons";
import { Button } from "./ui/button";
import { useViewAsRole } from "../contexts/ViewAsRoleContext";

/**
 * PreviewModeBanner Component
 * Displays a prominent banner when SuperAdmin or Admin is viewing the app as another role
 *
 * Features:
 * - Sticky positioning at top of viewport
 * - Shows current preview role
 * - Exit button to clear preview mode
 * - Warning colors (orange/yellow) for high visibility
 */
export function PreviewModeBanner() {
  const { isInPreviewMode, previewRole, clearPreviewRole } = useViewAsRole();

  if (!isInPreviewMode || !previewRole) {
    return null;
  }

  const getRoleDisplayName = (role: string) => {
    switch (role) {
      case "SuperAdmin":
        return "Super Admin";
      case "Admin":
        return "Admin";
      case "Member":
        return "Member";
      default:
        return role;
    }
  };

  return (
    <div className="sticky top-0 z-50 w-full bg-gradient-to-r from-orange-500 to-yellow-500 shadow-lg">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-white bg-opacity-30">
              <FontAwesomeIcon icon={faEye} className="h-4 w-4 text-white" />
            </div>
            <div>
              <p className="text-sm font-bold text-white">
                Preview Mode Active
              </p>
              <p className="text-xs text-white text-opacity-90">
                Viewing as: <span className="font-semibold">{getRoleDisplayName(previewRole)}</span>
              </p>
            </div>
          </div>
          <Button
            onClick={clearPreviewRole}
            size="sm"
            variant="outline"
            className="bg-white bg-opacity-20 text-white border-white border-opacity-30 hover:bg-white hover:bg-opacity-30"
          >
            <FontAwesomeIcon icon={faTimes} className="mr-2 h-4 w-4" />
            Exit Preview
          </Button>
        </div>
      </div>
    </div>
  );
}
